var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCabinLuggage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5ABCECA8-D14B-4F38-ABBC-0CF2FF8A9F57") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia-Viewports",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia-FE-1218",
    transform: "translate(-517, -594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/NotAble/1440",
    transform: "translate(17, 171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/Hand-luggage-a",
    transform: "translate(500, 423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,3.5 L31.5,3.5 L31.5,14 L35,14 L35,1.75 C35,0.7 34.3,0 33.25,0 L22.75,0 C21.7,0 21,0.7 21,1.75 L21,14 L24.5,14 L24.5,3.5 Z M36.75,17.5 L19.25,17.5 C16.275,17.5 14,19.775 14,22.75 L14,43.75 C14,46.725 16.275,49 19.25,49 L36.75,49 C39.725,49 42,46.725 42,43.75 L42,22.75 C42,19.775 39.725,17.5 36.75,17.5 Z M18.375,56 C19.9213973,56 21.175,54.7463973 21.175,53.2 C21.175,51.6536027 19.9213973,50.4 18.375,50.4 C16.8286027,50.4 15.575,51.6536027 15.575,53.2 C15.575,54.7463973 16.8286027,56 18.375,56 Z M37.625,56 C39.1713973,56 40.425,54.7463973 40.425,53.2 C40.425,51.6536027 39.1713973,50.4 37.625,50.4 C36.0786027,50.4 34.825,51.6536027 34.825,53.2 C34.825,54.7463973 36.0786027,56 37.625,56 Z",
    id: "Combined-Shape",
    fill: "#2800A0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinLuggage);
export default __webpack_public_path__ + "static/media/cabin_luggage.e408d9b65363ce789473ff5c15fbfc07.svg";
export { ForwardRef as ReactComponent };